import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { MEDIA } from 'vars/index'
import { NoContentBlock } from '../NoContentBlock'

export const FluidHeightNoContentBlockSC = styled(NoContentBlock)`
  ${MEDIA.MIN_1440} {
    flex-direction: row;
  }

  ${IconSC} + ${TextBoxSC} {
    margin-top: 0;
  }
`
